import { TaskFormDataTransferModel } from "../models";

/**Перемещаемые данные */
let transferData: TaskFormDataTransferModel;

export const useTaskFormDataTransfer = () => {
  /**Сохранить данные */
  const saveFormDataTransfer = (data: TaskFormDataTransferModel) => (transferData = data);
  /**Получить данные */
  const getFormDataTransfer = () => {
    if (!transferData) return;
    const data = new TaskFormDataTransferModel(transferData);
    transferData = undefined;
    return data;
  };

  return {
    /**Сохранить данные */
    saveFormDataTransfer,
    /**Получить данные */
    getFormDataTransfer,
  };
};
